// extracted by mini-css-extract-plugin
export var bannerImage = "banner-image-module--bannerImage--dbU8G";
export var titleContainer = "banner-image-module--titleContainer--kKEcQ";